/* eslint-disable no-param-reassign */
/* eslint-disable prefer-spread */
/* eslint-disable no-plusplus */
/* eslint-disable no-undef */
/* eslint-disable no-underscore-dangle */

import { logDebugging } from '../../log/logger';

export const getCmpFrame = () => {
  // start here at our window
  let frame = window;

  // if we locate the CMP iframe we will reference it with this
  let cmpFrame;

  // map of calls
  const cmpCallbacks = {};

  function postMessageHandler(event) {
    /**
     * when we get the return message, call the mapped callback
     */

    let json = {};

    try {
      /**
       * if this isn't valid JSON then this will throw an error
       */

      json = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
    } catch (ignore) {
      // logDebugging(ignore);
    }

    const payload = json.__tcfapiReturn;

    if (payload) {
      /**
       * messages we care about will have a payload
       */

      if (typeof cmpCallbacks[payload.callId] === 'function') {
        /**
         * call the mapped callback and then remove the reference
         */

        cmpCallbacks[payload.callId](payload.returnValue, payload.success);
        cmpCallbacks[payload.callId] = null;
      }
    }
  }

  window.removeEventListener('message', postMessageHandler, false);

  while (frame) {
    try {
      /**
       * throws a reference error if no frames exist
       */

      if (frame.frames.__tcfapiLocator) {
        cmpFrame = frame;
        break;
      }
    } catch (ignore) {
      logDebugging(ignore);
    }

    if (frame === window.top) {
      break;
    }

    frame = frame.parent;
  }

  /**
   * Set up a __tcfapi proxy method to do the postMessage and map the callback.
   * From the caller's perspective, this function behaves identically to the
   * CMP API's __tcfapi call
   */

  window.__tcfapi = (cmd, version, callback, arg) => {
    if (!cmpFrame) {
      callback({ msg: 'CMP not found' }, false);
    } else {
      const callId = `${Math.random()}`;
      const msg = {
        __tcfapiCall: {
          command: cmd,
          parameter: arg,
          version,
          callId,
        },
      };

      /**
       * map the callback for lookup on response
       */

      cmpCallbacks[callId] = callback;
      cmpFrame.postMessage(msg, '*');
    }
  };

  window.addEventListener('message', postMessageHandler, false);
};

/**
 * Mecanismo para la obtención de la cadena de consentimiento del usuario a
 * partir del gestor CMP que haya implementado el publisher.
 *
 * Nos basamos en la implementación del API del CMP de la IAB que deben seguir
 * todas las implementaciones de terceros.
 *
 * El objetivo es obtener la cadena de consentimiento de forma que podamos
 * proporcionarsela al player cuando la necesite.
 */
export const cmp2 = () => {
  // Mensajes de log encolados.
  const logQueue = [];

  // Inicialización del contador de tiempo para los mensajes de depuración.
  const initTime = performance.now();

  // Bandera que indica si se tenemos disponible un valor de consentimiento
  // ya sea porque nos ha respondido el CMP o porque hemos esperado
  // demasidao.
  let status = false;

  // Cadena de consentimiento del usuario
  let consentData = '';

  // Cola de peticiones de consentimiento realizadas por el player en el
  // periodo en el que aún no tenemos un valor válido.
  let queue = [];

  // Número máximo de intentos de comunicación con el CMP.
  const maxAttemps = 5;

  // Bandera que indica si ya hemos recibido respuesta a un ping.
  let pong = false;

  // Temporizador de tiempo máximo de respuesta del CMP ante una solicitud de
  // ping.
  let pingWatchdog = null;

  // Tiempo máximo de respuesta del CMP a una petición de ping.
  const pingWatchdogTime = 3e3;

  // Temporizador de tiempo máximo de espera de una respuesta del CMP.
  let watchdog = null;

  // Tiempo máximo de respuesta del CMP a una petición getConsentData.
  const watchdogTime = 6e3;

  // Intervalo para preguntar al CMP por la cadena de consentimiento.
  let interval;

  // Contador del número de veces que se ha intentado obtener la cadena de
  // consentimiento llamando al CMP.
  let attemps;

  //-------------------------------------------------------------------------

  //-------------------------------------------------------------------------

  //-------------------------------------------------------------------------

  function addLogToQueue() {
    // eslint-disable-next-line prefer-rest-params
    let newArguments = arguments;
    let index;
    let len;
    if (typeof newArguments === 'object') {
      if (typeof newArguments[0] !== 'string') {
        len = newArguments.length;
        const tmpArguments = [];
        tmpArguments[0] = `[CMP] (${performance.now() - initTime} ms) %o`;
        for (index = 0; index < len; index++) {
          tmpArguments[index + 1] = newArguments[index];
        }
        newArguments = tmpArguments;
      } else {
        newArguments[0] = `[CMP] (${performance.now() - initTime} ms) ${newArguments[0]}`;
      }
    }
    logQueue.push(newArguments);
  }

  function showLogQueued() {
    const len = logQueue.length;
    if (len > 0) {
      for (let index = 0; index < len; index++) {
        logDebugging.apply(console, logQueue[index]);
      }
    } else {
      logDebugging('Sin mensajes de depuración');
    }
  }

  /**
   * Manejador de respuestas a peticiones getConsentData.
   * @param {*} response
   */
  function consentDataHandler(response) {
    if (response.cmpStatus === 'loaded') {
      consentData = response.tcString;
      addLogToQueue(
        'Tenemos respuesta del CMP, establecemos el valor del consentData a: %s',
        consentData,
      );
      if (watchdog) {
        clearTimeout(watchdog);
        watchdog = null;
      }
      clearInterval(interval);
      status = true;
      // eslint-disable-next-line no-use-before-define
      processQueue();
    }
  }

  /**
   * Realizar una petición getConsentData al CMP en nuestro ancestro más
   * alto.
   */
  function getCmp() {
    addLogToQueue('Realizamos petición de consentData al CMP2.');
    __tcfapi('getTCData', 2, (tcReturn, success) => {
      if (success) {
        logDebugging('getCMP');
        logDebugging(tcReturn);
        addLogToQueue('Tenemos respuesta del CMP: %o', tcReturn);
        consentDataHandler(tcReturn);
      }
    });
  }
  /**
   * Manejador de respuestas a peticiones de ping.
   * @param {*} response
   */
  function pingHandler(response) {
    if (!pong && response.cmpStatus === 'loaded') {
      clearTimeout(pingWatchdog);
      pingWatchdog = null;
      pong = true;
      attemps = 1;
      interval = setInterval(() => {
        // eslint-disable-next-line no-plusplus
        if (attemps++ > maxAttemps) {
          clearInterval(interval);
        } else {
          addLogToQueue('Petición desde intervalo');
          getCmp();
        }
      }, 4e3);
    }
  }

  /**
   * Respondemos a todas las solicitudes de consentData del player que se
   * hayan podido encolar.
   */
  function processQueue() {
    addLogToQueue(
      'Procesamos las peticiones de consentData que se hayan encolado con: "%s"',
      consentData,
    );
    try {
      for (let i = 0; i < queue.length; i++) {
        addLogToQueue('Respondiendo a petición encolada con: "%s"', consentData);
        queue[i](consentData);
      }
      queue = [];
    } catch (error) {
      addLogToQueue('[ERROR] Al procesar las peticiones encoladas: %o', error);
    }
  }

  //-------------------------------------------------------------------------

  window.showCmpLogs = showLogQueued;

  //-------------------------------------------------------------------------

  function showConsentData() {
    logDebugging('[CMP] (%d) ConsentData: "%s"', performance.now() - initTime, consentData);
  }

  window.showConsentData = showConsentData;
  //-------------------------------------------------------------------------

  /**
   * Solicitud del player para conocer el consentData.
   */
  function getConsentData() {
    addLogToQueue('Solicitud de consentData version 2');
    return new Promise((resolve) => {
      if (status) {
        addLogToQueue(
          'Solicitud de consentData: Tenemos datos y respondemos inmediatamente con "%s"',
          consentData,
        );
        resolve(consentData);
      } else {
        addLogToQueue(
          'Solicitud de consentData: Aún no tenemos datos debemos esperar a que responda el CMP, encolamos la petición',
        );
        queue.push(resolve);
      }
    });
  }

  //-------------------------------------------------------------------------

  function getDirectConsentData() {
    return consentData;
  }

  /**
   * Superado el tiempo máximo de respuesta a una petición de ping al CMP.
   * Consideramos que no hay CPM.
   */
  function pingTimeout() {
    addLogToQueue('Timeout, en solicitud de ping a CMP, consideramos que no hay CMP');
    if (watchdog) {
      clearTimeout(watchdog);
      watchdog = null;
    }
    pingWatchdog = null;
    status = true;
    processQueue();
  }

  //-------------------------------------------------------------------------

  /**
   * Superado el tiempo máximo de respuesta del CMP ante una petición
   * getConsentData, Para no bloquear las peticiones desde el player de forma
   * indefinida, se responderá a las peticiones encoladas con una cadena
   * vacía. En caso de que la respuesta desde el CMP se produjese
   * posteriormente se actualizará el consentData y estará disponible para
   * futuras peticiones desde el player.
   */
  function timeout() {
    addLogToQueue('Timeout, no tenemos respuesta del CMP');
    watchdog = null;
    status = true;
    processQueue();
  }

  //-------------------------------------------------------------------------

  /**
   * Realiza una petición de ping al CMP en nuestro ancestro más alto.
   */
  function ping() {
    __tcfapi('ping', 2, (pingReturn, success) => {
      if (success) {
        addLogToQueue('Tenemos respuesta del CMP: %o', pingReturn);
        pingHandler(pingReturn);
      }
    });
  }

  /**
   * Proceso inicial:
   * - Activa el manejador de respuestas del CMP.
   * - Realiza un ping al CMP.
   * - Activa el temporizador de tiempo máximo de espera.
   * - Realiza un solicitud getConsentData al CMP.
   */
  function init() {
    addLogToQueue('Inicializar sistema CMP_2');
    ping();
    pingWatchdog = setTimeout(pingTimeout, pingWatchdogTime);
    watchdog = setTimeout(timeout, watchdogTime);
    getCmp();
  }

  //-------------------------------------------------------------------------

  //-------------------------------------------------------------------------

  //  init();

  //-------------------------------------------------------------------------

  return {
    init,
    getConsentData,
    getDirectConsentData,
    getVersion: () => 'version 2',
  };
};
